import { Component } from '@angular/core';
import { ItemProfitibilityReportStoreService } from './item-profitibility-report-store.service';
import { ProductService } from '../../shared';
import { ProductCategoryService } from '../../shared/services/product-category.service';
import { ReportService } from '../shared/services/report.service';
import { ItemProfitabilityTableComponent } from './item-profitability-table/item-profitability-table.component';
import { ControlsFormComponent } from './controls-form/controls-form.component';

@Component({
    selector: 'app-item-profitibility-report',
    templateUrl: './item-profitibility-report.component.html',
    providers: [
        ItemProfitibilityReportStoreService,
        ProductService,
        ProductCategoryService,
        ReportService
    ],
    standalone: true,
    imports: [ControlsFormComponent, ItemProfitabilityTableComponent]
})
export class ItemProfitibilityReportComponent {
  constructor(private store: ItemProfitibilityReportStoreService) {}
}
